import { call } from "redux-saga/effects";
import {
  GET_ALL_CHATS,
  GET_ATTACHMENT,
  GET_IDENTITY,
  GET_PUBLIC_CHANNELS,
  SEARCH_USERS
} from "../constants/ActionTypes";
import {
  APP_START_DATA_TIMEOUT,
  DEFAULT_TIMEOUT,
  GET_ATTACHMENT_TIMEOUT,
  GET_IDENTITY_TIMEOUT
} from "../constants/AppConstants";


/**
 * Helper method to return the correct timeout delay for each api request
 */
export const getTimeoutLength = type => {
  switch (type) {
    case GET_ATTACHMENT:
      return GET_ATTACHMENT_TIMEOUT;
    case GET_IDENTITY:
      return GET_IDENTITY_TIMEOUT;
    case GET_ALL_CHATS:
    case GET_PUBLIC_CHANNELS:
    case SEARCH_USERS:
      return APP_START_DATA_TIMEOUT;
    default:
      return DEFAULT_TIMEOUT;
  }
};

// Todo : finish this and then use it
export const restCallGenWrapper = (generator, handleError, maxTries) => {
  return function* multipleAttempts (...args) {
    let n = 0;
    while (n <= maxTries) {
      try {
        yield call(generator, ...args);
        break;
      } catch (e) {
        // Log errors here until maxTries has been hit, to prevent
        // spamming the user with messages.
        if (n < maxTries) {
          // yield log(e);
          console.log('logging stuff...');
        } else {
          yield handleError(e);
        }
      }
    }
  }
};

// todo : need to make one for websockets